import React from "react";
import {
  canNavigateToClassroom,
  formatSchoolYear,
  resolveTeacherName,
  resolveTranslatedClassroomName,
} from "../../details/utils/childClassroomUtils";

const toneClasses = {
  active: "border-emerald-200 bg-emerald-50/80 text-emerald-900 dark:border-emerald-500/50 dark:bg-emerald-950/30 dark:text-emerald-100",
  future: "border-sky-200 bg-sky-50/80 text-sky-900 dark:border-sky-500/50 dark:bg-sky-950/30 dark:text-sky-100",
  history: "border-slate-200 bg-slate-50/80 text-slate-800 dark:border-slate-600/60 dark:bg-slate-900/40 dark:text-slate-100",
};

export default function ChildClassroomCard({ classroom, tone = "history", onOpen, yearFallback, startDateLabel }) {
  const teacherName = resolveTeacherName(classroom);
  const canOpen = canNavigateToClassroom(classroom) && onOpen;
  const content = (
    <>
      <div className="flex flex-col gap-1">
        <span className="font-semibold">{resolveTranslatedClassroomName(classroom)}</span>
        {teacherName && <span className="text-xs opacity-80">{teacherName}</span>}
      </div>
      <div className="mt-3 flex flex-wrap gap-2 text-xs font-semibold">
        <span className="rounded-full bg-white/70 px-2 py-0.5 dark:bg-gray-900/50">
          {formatSchoolYear(classroom, yearFallback)}
        </span>
        {classroom?.startDate && startDateLabel && (
          <span className="rounded-full bg-white/70 px-2 py-0.5 dark:bg-gray-900/50">
            {startDateLabel}
          </span>
        )}
      </div>
    </>
  );

  const className = `w-full rounded-2xl border p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 motion-reduce:hover:translate-y-0 ${
    toneClasses[tone] || toneClasses.history
  }`;

  if (canOpen) {
    return (
      <button type="button" className={className} onClick={() => onOpen(classroom)}>
        {content}
      </button>
    );
  }

  return <div className={className}>{content}</div>;
}
